import { useEffect } from "react";
import Banner from "../components/TradeTerminal/Banner";
import Features from "../components/TradeTerminal/Features";
import Plate from "../components/TradeTerminal/Plate";
import Trade from "../components/TradeTerminal/Trade";
import Tabs from "../components/TradeTerminal/Tabs";
import Deposit from "../components/TradeTerminal/Deposit";

function TradeTerminal() {
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    return (
        <div className="bg-[#EFEFEF] relative overflow-hidden">
            <Banner />
            <Features />
            <Plate />
            <Trade />
            <Tabs />
            <Deposit />
        </div>
    );
}

export default TradeTerminal;
